import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown",
  "use": "dropdown-usage",
  "content": "<symbol id=\"dropdown\">\n  <polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\" />\n  <polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol